// 验证手机号
export function inspectPhone(val) {
  let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  return myreg.test(val);
}

// 验证非负浮点数
export function inspectFloat(val) {
  let myreg = /^\d+(\.\d+)?$/;
  return myreg.test(val);
}

// 验证价格(非负浮点数,最多两位小数)
export function inspectPrice(val) {
  let myreg = /^(0|([1-9]\d*))(\.\d{1,2})?$/;
  return myreg.test(val);
}
// 验证营业执照号
 export const isValidBusinessLicense = (code) => {
  // 转换为大写
  code = code.toUpperCase().replace(/\s/g, '');

  // 长度验证
  if (code.length !== 18) return false;

  // 基础正则验证
  const reg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
  if (!reg.test(code)) return false;

  // 校验码验证
  const weights = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28];
  const charMap = "0123456789ABCDEFGHJKLMNPQRTUWXY";

  let sum = 0;
  for (let i = 0; i < 17; i++) {
    const char = code.charAt(i);
    const value = charMap.indexOf(char);
    if (value === -1) return false;
    sum += value * weights[i];
  }

  const mod = 31;
  const remainder = sum % mod;
  const checkValue = (mod - remainder) % mod;

  return charMap.charAt(checkValue) === code.charAt(17);
}